import { ChevronRight } from "lucide-react";

export const CategoryGrid = ({ categories, theme, onCategorySelect }) => {
  if (!categories || categories.length === 0) return null;

  return (
    <section className="py-16" id="categories">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: theme.primary_color }}
          >
            Shop by Category
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto">
            Browse our carefully curated collection of premium memorial products
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {categories.map((category) => (
            <div 
              key={category.category_id}
              className="group relative overflow-hidden rounded-xl cursor-pointer"
              onClick={() => onCategorySelect(category.category_id)}
            >
              <div className="aspect-square">
                <img 
                  src={category.image_url || `https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400`}
                  alt={category.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white text-lg font-semibold mb-1">
                  {category.name}
                </h3>
                <p className="text-white/80 text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
                  Shop Now <ChevronRight className="w-4 h-4" />
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
